import { EventEmitter } from 'modules/event-emitter';

export interface PatientEvents {
  'activity-created': { meetingID: string };
}

export const supportMeetingEmitter = new EventEmitter<PatientEvents>();
